module.exports = __webpack_public_path__ + "img/img_product2.a2029e4b.png";